import {Modal} from "react-bootstrap";
import React from "react";

type Props = {
    onCancel?:Function;
    show:boolean
}
export const InfoModal = (props: Props) => {
    return (
        <Modal
            show={props.show}
            onClick={() => {
                if(props?.onCancel) {
                    props?.onCancel();
                }
            }}
            centered={true}
            backdrop='static'
         >
            <Modal.Body className='pt-5'>
                <div className=''>
                    <div style={{padding: '20px'}} className='d-flex justify-content-center'>
                        Veuillez remplir le champ obligatoire
                    </div>
                    <div className='d-flex flex-row align-items-center justify-content-center'>
                        <button
                            type='submit'
                            className='btn btn-primary'
                            onClick={() => {
                                if(props?.onCancel) {
                                    props?.onCancel();
                                }
                            }}
                        >
                            <span className='indicator-label'>
                                OK
                                </span>
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
);
};
